import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteLeadItem, GetAllLeads } from '../../store/actions/new/leadDataAction';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import SearchForm from '../default/search/searchForm';
import NoContentFound from '../default/not-found/notFound';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ShimmerImage from '../default/popup/shimmerImage/shimmerImage';
import ExportLeadPopup from './popup/exportLeadPopup';
import { InitialAvatar } from '../default/utils/defaultAvatar';
import DataModelPopup from '../default/popup/dataModel/contentModelPopup';
import SingleLeadData from './single/singLeadData';
import { truncateText } from '../default/utils/truncateText';
import { handleCtrlLink } from '../default/utils/ctrlLink';


const LeadList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [pageCount, setPageCount] = useState(1);
    const [copyIcons, setCopyIcons] = useState(new Map());
    const navigate = useNavigate();
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();
    const [openPopup, setPopup] = useState(false);
    const [openDataPopup, setDataPopup] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [dataPopupId, setDataPopupId] = useState('');

    const dispatch = useDispatch();
    const { leadDataReducer } = useSelector((state) => state);
    const { isLoading, leadAllData, error } = leadDataReducer;
    const { data, pagination } = leadAllData;

    const handlePopup = () => {
        setPopup(true);
    }
    const handleCloseModal = () => {
        setDataPopup(false);
    };
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };
    useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!leadAllData || !leadAllData.data || leadAllData.data.length === 0) {
                let postData = {
                    page: 1,
                    keyword: ''
                };
                dispatch(GetAllLeads(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchLeads();
        }
        prevSearchTermRef.current = searchTerm;
        // dropdown click outside detector
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [dispatch, data, searchTerm]);

    // Search Lead
    const searchLeads = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(GetAllLeads(postData));
        setLoading(false);
    }
    // Load more lead
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(GetAllLeads(postData));
        }
    };
    //remove connection item
    const MySwal = withReactContent(Swal)
    const handleDeleteLead = (id) => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(DeleteLeadItem(id));

            }
        });

    }

    // Add this function near your other utility functions
    const copyToClipboard = async (text, buttonId) => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(text);
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-check-double-line"));
                return true;
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-check-double-line"));
                return true;
            }
        } catch (err) {
            console.error('Failed to copy: ', err);
            return false;
        }
        finally {
            // Reset the message after 2 seconds
            setTimeout(() => {
                setCopyIcons(prev => new Map(prev).set(buttonId, "ri-file-copy-line"));
            }, 2000);
        }
    };
    const handleDataPopup = (dataId) => {
        setDataPopup(false);
        setDataPopupId(null);
        setTimeout(() => {
            setDataPopupId(dataId);
            setDataPopup(true);
        }, 100);
    }
   

    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Lead Lists</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search card...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter" onClick={handlePopup}>
                        <i className="ri-export-line"></i>
                        <span>Export</span>
                    </div>
                    <Link to="/lead/new" className="list-filter add-new-btn">
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </Link>
                </div>
            </div>
            <div className="card-wrapper-list connection-list"> {error && error.message}
                {Array.isArray(data) && data.length > 0 && (
                    <div className='card-view-wrapper'>
                        {data && data.map((item, index) => (
                            <div className={`sng-card-item${openDropdown === null ? '' : ' disabled'}`} key={index} onClick={() =>{handleDataPopup(item.id)}}>
                                <div className='card-profile-photo'>
                                    <Link className='info-top-link' 
                                        onClick={(e) => handleCtrlLink(e, `/lead/single/${item.id}`)} 
                                        to={`/lead/single/${item.id}`}>
                                        {item.photo ? (
                                            <ShimmerImage
                                                src={item.photo}
                                                alt={item.firstName}
                                                width={65}
                                            />
                                        ) : (
                                            <InitialAvatar 
                                                title={`${item.firstName} ${item.lastName}`}
                                                size={65}
                                            />
                                        )}
                                    </Link>
                                </div>
                                <div className='card-profile-info'>
                                    <Link className='info-top-link' 
                                        onClick={(e) => handleCtrlLink(e, `/lead/single/${item.id}`)} 
                                        to={`/lead/single/${item.id}`}
                                    >
                                        <h4>{item.firstName} {item.lastName}</h4>
                                        <p className={item.title ? "prf-title" : "pld-title"}>{item.title ? item.title : "Empty title"}</p>
                                    </Link>
                                    <div className='info-links'>

                                        {item.adi_info.website !== null && (
                                            <div className="inline-flex-item">
                                                <button
                                                    className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        toggleDropdown((index + "_website"));
                                                    }}
                                                >
                                                    < i className="ri-global-fill"></i>

                                                </button>

                                                <div className='list-edit-dropdown' onClick={(e) => {e.stopPropagation()}}>
                                                    {openDropdown === (index + "_website") && (
                                                        <ul>
                                                            {item.adi_info.website.map((website) => (
                                                                <div key={website.value} className="list-link-wrapper">
                                                                    <Link key={website.value} to={website.value} target='_blank'>
                                                                        {truncateText(website.value)}
                                                                    </Link>
                                                                    <button
                                                                        className="copy-btn"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            copyToClipboard(website.value, `website-${index}-${website.value}`);
                                                                        }}
                                                                    >
                                                                        <i className={copyIcons.get(`website-${index}-${website.value}`) || "ri-file-copy-line"}></i>
                                                                    </button>
                                                                </div>

                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {item.adi_info.email !== null && (
                                            <div className="inline-flex-item">
                                                <button
                                                    className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        toggleDropdown((index + "_email"));
                                                    }}
                                                >
                                                    < i className="ri-mail-line"></i>
                                                </button>
                                                <div className='list-edit-dropdown' onClick={(e) => {e.stopPropagation()}}>
                                                    {openDropdown === (index + "_email") && (
                                                        <ul>
                                                            {item.adi_info.email.map((email) => (
                                                                <div key={email.value} className="list-link-wrapper">
                                                                    <Link to={`mailto:${email.value}`}>
                                                                        {truncateText(email.value)}
                                                                    </Link>
                                                                    <button
                                                                        className="copy-btn"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            copyToClipboard(email.value, `email-${index}-${email.value}`);
                                                                        }}
                                                                    >
                                                                        <i className={copyIcons.get(`email-${index}-${email.value}`) || "ri-file-copy-line"}></i>
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {item.adi_info.phone !== null && (
                                            <div className="inline-flex-item">
                                                <button
                                                    className="lead_action_menu icon-button list-btn dropdown-toggle-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleDropdown((index + "_phone"));
                                                    }}
                                                >
                                                    < i className="ri-phone-line"></i>
                                                </button>
                                                <div className='list-edit-dropdown' onClick={(e) => {e.stopPropagation()}}>
                                                    {openDropdown === (index + "_phone") && (
                                                        <ul>
                                                            {item.adi_info.phone.map((phone) => (
                                                                <div key={phone.value} className="list-link-wrapper">
                                                                    <Link key={phone.value} to={`tel:${phone.value}`}>
                                                                        {phone.value}
                                                                    </Link>
                                                                    <button
                                                                        className="copy-btn"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            copyToClipboard(phone.value, `phone-${index}-${phone.value}`);
                                                                        }}
                                                                    >
                                                                        <i className={copyIcons.get(`phone-${index}-${phone.value}`) || "ri-file-copy-line"}></i>
                                                                    </button>
                                                                </div>

                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {!isLoading && !data &&
                    <NoContentFound title="No lead found!" />
                }
                {isLoading &&
                    <div className='grid-item-wrapper'>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={65}
                            imageHeight={65}
                            text

                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={65}
                            imageHeight={65}
                            text

                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={65}
                            imageHeight={65}
                            text

                        />

                    </div>
                }
                {!isLoading && pagination && pagination.page_last > pagination.page && (
                    <div className="load-more-container">
                        <button
                            className="load-more-btn"
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}

            </div>
            <DataModelPopup openModal={openDataPopup} setOpen={setDataPopup} sourceUrl={`/lead/single/${dataPopupId}`} bodyData={<SingleLeadData popupItemId={dataPopupId} onClose={handleCloseModal} />} />
            <ExportLeadPopup openModal={openPopup} setOpen={setPopup} />
        </div>
    );
}

export default LeadList;
